<template>
  <custom-dialog class="isp-task-detail-dialog" :title="$t('dms_export_ispsim_dialog.xzjhyfqj')" width="400px" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <el-form>
        <el-form-item :label="$t('dms_export_ispsim_dialog.ji_huo_yue_fen')">
          <custom-date-picker
            v-model="reportMonthTime"
            type="monthrange"
            value-format="yyyy-MM"
            :picker-options="pickerIspOptionsMonth"
            :placeholder="$t('dms_export_ispsim_dialog.xuan_ze_yue')"
            prefix-icon="icon icon-calendar"
            :clearable="false"
            style="width: 320px"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" :disabled="!reportMonthTime.length" @click="exportDay">{{ $t('Common.com_export') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    formSearch: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      startDate: '',
      reportMonthTime: [],
      pickerIspOptionsMonth: {
        firstDayOfWeek: 1,
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate;
          if (maxDate) {
            this.startDate = '';
          }
        },
        disabledDate: (time) => moment(time).isAfter(this.$getLocalTime(), 'month')
          || (this.startDate && moment(time).isAfter(moment(this.startDate).add(2, 'months'), 'month'))
          || (this.startDate && moment(time).isBefore(moment(this.startDate).subtract(2, 'months'), 'month')),
      },
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    // 数据导出
    exportDay: function () {
      const startMonth = this.reportMonthTime[0];
      const endMonth = this.reportMonthTime[1];
      this.$exportFlie(apis.simIspMonthExport, { ...this.formSearch, startMonth, endMonth }).then(() => {
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.isp-task-detail-dialog {
  .table-bd {
    height: 500px;
  }
}
</style>
